import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hasLoggedInHeaderEnvironmentBanner } from '@components/LoggedInHeader';

// Toasts sit top-right, so they start just below the sticky header. The
// environments that show a banner above the header push it down by 2.5rem
// (the same offset MainLayout applies to the page body).
const getToastTopOffset = () => {
    const bannerOffset = hasLoggedInHeaderEnvironmentBanner(process.env.REACT_APP_BB_ENV) ? '2.5rem + ' : '';
    return `calc(var(--header-height) + ${bannerOffset}0.75rem)`;
};

/**
 * Provider component that configures react-toastify with dark mode support
 */
const ToastProvider = ({ children }) => {
    return (
        <>
            {children}
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="auto"
                style={{ width: "auto", maxWidth: "600px", top: getToastTopOffset() }}
                toastStyle={{ 
                    width: "auto", 
                    maxWidth: "600px",
                    backgroundColor: "var(--toast-bg)",
                    color: "var(--toast-text)"
                }}
            />
        </>
    );
};

ToastProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default ToastProvider; 